


// Generated from io.spcfy.orders.persistence.SampleConfigurationType

export type SampleConfigurationTypeKey =
  "SINGLE_SAMPLE_PAIRS" |
  "COMBINED_SAMPLE_PAIRS" |
  "MERGED_AND_TRIMMED_SAMPLES" |
  "MERGED_SAMPLES" |
  "TRIMMED_SAMPLES";


export interface SampleConfigurationTypeDTO {
  key: SampleConfigurationTypeKey;
  label: string;
  impliesTrimmed: boolean;
  impliesMerged: boolean;    
}


export const SampleConfigurationTypes: Record<SampleConfigurationTypeKey, SampleConfigurationTypeDTO> = {
  SINGLE_SAMPLE_PAIRS: { key: "SINGLE_SAMPLE_PAIRS", label: "Paired-End", impliesTrimmed: false, impliesMerged: false },
  COMBINED_SAMPLE_PAIRS: { key: "COMBINED_SAMPLE_PAIRS", label: "Multiplexed Paired-End", impliesTrimmed: false, impliesMerged: false },
  MERGED_AND_TRIMMED_SAMPLES: { key: "MERGED_AND_TRIMMED_SAMPLES", label: "Single-Strand Trimmed - Illumina", impliesTrimmed: true, impliesMerged: true },
  MERGED_SAMPLES: { key: "MERGED_SAMPLES", label: "Single-Strand - Illumina", impliesTrimmed: false, impliesMerged: true },
  TRIMMED_SAMPLES: { key: "TRIMMED_SAMPLES", label: "Paired-End Trimmed", impliesTrimmed: true, impliesMerged: false }
};
